import { ImportOutlined } from '@ant-design/icons';
import { SubmitButton } from '@framework/form/form/submit/SubmitButton.tsx';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { filterCatalogLevelsBySelection } from './utils/filterCatalogLevelsBySelection.ts';
import { type ILayerCatalogLevels } from './utils/parseLayerCatalogLevels.ts';

export interface ILayerCatalogImportSubmitButtonProps {
  preview: ILayerCatalogLevels | null;
}

/**
 * Submit "Importa" della modale di import catalogo. Osserva `selectedKeys`
 * (via `useWatch`, quindi deve stare dentro il `FormHandler`) e si disabilita
 * finché non c'è almeno una voce selezionata da importare — non solo quando il
 * catalogo è vuoto.
 */
export function LayerCatalogImportSubmitButton(
  props: ILayerCatalogImportSubmitButtonProps,
) {
  const { preview } = props;
  const selectedKeys = useWatch({ name: 'selectedKeys' }) as
    | string[]
    | undefined;

  const hasSelection = useMemo(() => {
    if (!preview) return false;
    const levels = filterCatalogLevelsBySelection(preview, selectedKeys ?? []);
    return levels.layers.length > 0 || levels.groups.length > 0;
  }, [preview, selectedKeys]);

  return (
    <SubmitButton
      enabledWhenPristine
      pristineMessage={null}
      disabled={!hasSelection}
      icon={<ImportOutlined aria-hidden />}
    >
      Importa
    </SubmitButton>
  );
}
